// use https://desmos.com/calculator
// import calculateGallonsRemainingV330 from './calculation/calculationV330';

const { values, orderBy } = require('lodash');

const TANKS = {
  V_275: {
    key: 'V_275',
    name: '275 Gallon Vertical',
    height: 42,
    offset: 0,
    gallons: 275,
    actualCapacity: 255,
    isActive: true,
    sortId: 1,
    calculateGallonsRemaining: (dist, offset = TANKS.V_275.offset) => {
      const distance = dist + offset;
      const value =
        0.0024514 * (distance * distance * distance) +
        -0.144662 * (distance * distance) +
        -4.60448 * distance +
        266.224;
      if (value > TANKS.V_275.gallons) {
        return TANKS.V_275.gallons;
      } else if (value < 0) {
        return 0;
      }
      return Math.round(value);
    },
  },
  H_275: {
    key: 'H_275',
    name: '275 Gallon Horizontal',
    height: 27,
    offset: 0,
    gallons: 275,
    actualCapacity: 255,
    isActive: true,
    sortId: 2,
    calculateGallonsRemaining: (dist, offset = TANKS.H_275.offset) => {
      const distance = dist + offset;
      const value =
        0.00917227 * (distance * distance * distance) +
        -0.373445 * (distance * distance) +
        -6.84234 * distance +
        275.6;
      if (value > TANKS.H_275.gallons) {
        return TANKS.H_275.gallons;
      } else if (value < 0) {
        return 0;
      }
      return Math.round(value);
    },
  },
  V_330: {
    key: 'V_330',
    name: '330 Gallon Vertical',
    height: 44,
    width: 27,
    length: 72,
    offset: 0.5,
    gallons: 330,
    actualCapacity: 319,
    isActive: true,
    sortId: 4,
    calculateGallonsRemaining: (dist, offset = TANKS.V_330.offset) => {
      const distance = dist + offset;
      const value =
        0.00330031 * (distance * distance * distance) +
        -0.216963 * (distance * distance) +
        -4.25883 * distance +
        332.368;
      if (value > TANKS.V_330.gallons) {
        return TANKS.V_330.gallons;
      } else if (value < 0) {
        return 0;
      }
      return Math.round(value);
    },
  },
  H_330: {
    key: 'H_330',
    name: '330 Gallon Horizontal',
    height: 27,
    gallons: 330,
    offset: 0,
    actualCapacity: 310,
    isActive: true,
    sortId: 5,
    calculateGallonsRemaining: (dist, offset = TANKS.H_330.offset) => {
      const distance = dist + offset;
      const value =
        0.0100555 * (distance * distance * distance) +
        -0.407247 * (distance * distance) +
        -8.63519 * distance +
        331.056;
      if (value > TANKS.H_330.gallons) {
        return TANKS.H_330.gallons;
      } else if (value < 0) {
        return 0;
      }
      return Math.round(value);
    },
  },
  ROTH_275: {
    key: 'ROTH_275',
    name: 'Roth 275 Gallon',
    height: 56,
    offset: -2,
    gallons: 275,
    actualCapacity: 255,
    isActive: true,
    sortId: 3,
    calculateGallonsRemaining: (dist, offset = TANKS.ROTH_275.offset) => {
      const distance = dist + offset;
      const value =
        0.000107775 * (distance * distance * distance) +
        -0.00533041 * (distance * distance) +
        -4.82524 * distance +
        263.589;
      if (value > TANKS.ROTH_275.gallons) {
        return TANKS.ROTH_275.gallons;
      } else if (value < 0) {
        return 0;
      }
      return Math.round(value);
    },
  },
  ROUND_138: {
    key: 'ROUND_138',
    name: '138 Gallon Round',
    height: 26,
    offset: 0,
    gallons: 138,
    actualCapacity: 130,
    isActive: true,
    sortId: 9,
    calculateGallonsRemaining: (dist, offset = TANKS.ROUND_138.offset) => {
      const distance = dist + offset;
      const value =
        0.00970721 * (distance * distance * distance) +
        -0.374164 * (distance * distance) +
        -2.12012 * distance +
        138.298;
      if (value > TANKS.ROUND_138.gallons) {
        return TANKS.ROUND_138.gallons;
      }
      return Math.round(value);
    },
  },
  H_3000: {
    key: 'H_3000',
    name: '3000 Gallon Horizontal',
    height: 73,
    offset: 0,
    gallons: 3000,
    actualCapacity: 3000,
    isActive: false,
    sortId: 21,
    calculateGallonsRemaining: (dist, offset = TANKS.H_3000.offset) => {
      const distance = dist + offset;
      const value =
        0.00903104 * (distance * distance * distance) +
        -1.03563 * (distance * distance) +
        -13.9267 * distance +
        3020.08;
      if (value > TANKS.H_3000.gallons) {
        return TANKS.H_3000.gallons;
      }
      return Math.round(value);
    },
  },
  ROTH_400: {
    key: 'ROTH_400',
    name: 'Roth 400 Gallon',
    height: 60,
    offset: 0,
    gallons: 400,
    actualCapacity: 380,
    isActive: true,
    sortId: 6,
    calculateGallonsRemaining: (dist, offset = TANKS.ROTH_400.offset) => {
      const distance = dist + offset;
      const value = 398.179 + -6.73141 * distance;
      if (value > TANKS.ROTH_400.gallons) {
        return TANKS.ROTH_400.gallons;
      }
      return Math.round(value);
    },
  },
  G_240: {
    key: 'G_240',
    name: '240 Gallon Vertical',
    height: 47,
    offset: 0,
    gallons: 240,
    actualCapacity: 225,
    isActive: true,
    sortId: 8,
    calculateGallonsRemaining: (dist, offset = TANKS.G_240.offset) => {
      const distance = dist + offset;
      const value =
        0.00172117 * (distance * distance * distance) +
        -0.126739 * (distance * distance) +
        -3.13364 * distance +
        246.289;
      if (value > TANKS.G_240.gallons) {
        return TANKS.G_240.gallons;
      }
      return Math.round(value);
    },
  },
  V_230: {
    key: 'V_230',
    name: '230 Gallon Vertical',
    height: 44,
    offset: 0,
    gallons: 230,
    actualCapacity: 215,
    isActive: true,
    sortId: 7,
    calculateGallonsRemaining: (dist, offset = TANKS.V_230.offset) => {
      const distance = dist + offset;
      const value =
        0.00180086 * (distance * distance * distance) +
        -0.118857 * (distance * distance) +
        -3.53704 * distance +
        231.166;
      if (value > TANKS.V_230.gallons) {
        return TANKS.V_230.gallons;
      }
      return Math.round(value);
    },
  },
  UK_550: {
    key: 'UK_550',
    name: '550 Gallon UK',
    height: 44,
    offset: 0,
    gallons: 550,
    actualCapacity: 530,
    isActive: false,
    sortId: 20,
    calculateGallonsRemaining: (dist, offset = TANKS.UK_550.offset) => {
      const distance = dist + offset;
      const value =
        0.00430098 * (distance * distance * distance) +
        -0.25149 * (distance * distance) +
        -9.67929 * distance +
        544.338;
      if (value > TANKS.UK_550.gallons) {
        return TANKS.UK_550.gallons;
      }
      return Math.round(value);
    },
  },
  US_550: {
    key: 'US_550',
    name: '550 Gallon US',
    height: 48,
    offset: 0,
    gallons: 550,
    actualCapacity: 530,
    isActive: false,
    sortId: 12,
    calculateGallonsRemaining: (dist, offset = TANKS.US_550.offset) => {
      const distance = dist + offset;
      const value =
        0.00564696 * (distance * distance * distance) +
        -0.406218 * (distance * distance) +
        -5.10614 * distance +
        553.434;
      if (value > TANKS.US_550.gallons) {
        return TANKS.US_550.gallons;
      }
      return Math.round(value);
    },
  },
  G_1000_130_Inch: {
    key: 'G_1000_130_Inch',
    name: '1000 Gallon 130',
    height: 52,
    offset: 0,
    gallons: 1000,
    actualCapacity: 960,
    isActive: false,
    sortId: 13,
    calculateGallonsRemaining: (
      dist,
      offset = TANKS.G_1000_130_Inch.offset,
    ) => {
      const distance = dist + offset;
      const value =
        0.0101924 * (distance * distance * distance) +
        -0.778898 * (distance * distance) +
        -6.40388 * distance +
        1016.88;
      if (value > TANKS.G_1000_130_Inch.gallons) {
        return TANKS.G_1000_130_Inch.gallons;
      }
      return Math.round(value);
    },
  },
  G_1000_64_Inch: {
    key: 'G_1000_64_Inch',
    name: '1000 Gallon 64',
    height: 64,
    offset: 0,
    gallons: 1000,
    actualCapacity: 960,
    isActive: false,
    sortId: 14,
    calculateGallonsRemaining: (dist, offset = TANKS.G_1000_64_Inch.offset) => {
      const distance = dist + offset;
      const value =
        0.00428302 * (distance * distance * distance) +
        -0.411379 * (distance * distance) +
        -7.07362 * distance +
        1008.3;
      if (value > TANKS.G_1000_64_Inch.gallons) {
        return TANKS.G_1000_64_Inch.gallons;
      }
      return Math.round(value);
    },
  },
  VC_500: {
    key: 'VC_500',
    name: '500 Gallon Vertical 65',
    height: 65,
    offset: 1.75,
    gallons: 500,
    actualCapacity: 480,
    isActive: false,
    sortId: 15,
    calculateGallonsRemaining: (dist, offset = TANKS.VC_500.offset) => {
      const distance = dist + offset;
      const value = -7.6935 * distance + 500;
      if (value > TANKS.VC_500.gallons) {
        return TANKS.VC_500.gallons;
      }
      return Math.round(value);
    },
  },
  VC_500_60: {
    key: 'VC_500_60',
    name: '500 Gallon Vertical 60',
    height: 60,
    offset: 1.75,
    gallons: 500,
    actualCapacity: 480,
    isActive: false,
    sortId: 16,
    calculateGallonsRemaining: (dist, offset = TANKS.VC_500.offset) => {
      const distance = dist + offset;
      const value = -8.33 * distance + 500;
      if (value > TANKS.VC_500.gallons) {
        return TANKS.VC_500.gallons;
      }
      return Math.round(value);
    },
  },
  VC_330: {
    key: 'VC_330',
    name: '330 Gallon Vertical 72',
    height: 72,
    offset: 0,
    gallons: 330,
    actualCapacity: 310,
    isActive: false,
    sortId: 17,
    calculateGallonsRemaining: (dist, offset = TANKS.VC_330.offset) => {
      const distance = dist + offset;
      const value = -4.58 * distance + 330;
      if (value > TANKS.VC_330.gallons) {
        return TANKS.VC_330.gallons;
      }
      return Math.round(value);
    },
  },
  H_500: {
    key: 'H_500',
    name: '500 Gallon Horizontal 48',
    height: 48,
    offset: 0,
    gallons: 500,
    actualCapacity: 470,
    isActive: false,
    sortId: 18,
    calculateGallonsRemaining: (dist, offset = TANKS.H_500.offset) => {
      const distance = dist + offset;
      const value =
        0.0050612 * (distance * distance * distance) +
        -0.3654 * (distance * distance) +
        -4.887 * distance +
        512;
      if (value > TANKS.H_500.gallons) {
        return TANKS.H_500.gallons;
      }
      return Math.round(value);
    },
  },
  H_1000: {
    key: 'H_1000',
    name: '1000 Gallon Horizontal 48',
    height: 48,
    offset: 0,
    gallons: 1000,
    actualCapacity: 960,
    isActive: false,
    sortId: 19,
    calculateGallonsRemaining: (dist, offset = TANKS.H_1000.offset) => {
      const distance = dist + offset;
      const value =
        0.0100214 * (distance * distance * distance) +
        -0.723637 * (distance * distance) +
        -9.73 * distance +
        1016;
      if (value > TANKS.H_1000.gallons) {
        return TANKS.H_1000.gallons;
      }
      return Math.round(value);
    },
  },
  KING_1000: {
    key: 'KING_1000',
    name: 'Kingspan ES1000B',
    height: 51,
    offset: 0,
    gallons: 1000,
    actualCapacity: 975,
    isActive: true,
    sortId: 11,
    calculateGallonsRemaining: (dist, offset = TANKS.KING_1000.offset) => {
      const distance = dist + offset;
      const value =
        -0.000681871 * (distance * distance * distance) +
        0.0172259 * (distance * distance) +
        -4.51763 * distance +
        281.938;
      if (value > TANKS.KING_1000.gallons) {
        return TANKS.KING_1000.gallons;
      }
      return Math.round(value);
    },
  },
  ROTH_165: {
    key: 'ROTH_165',
    name: 'Roth 165 Gallon',
    height: 56,
    width: 28,
    length: 29,
    offset: 0,
    gallons: 165,
    actualCapacity: 156,
    isActive: true,
    sortId: 10,
    calculateGallonsRemaining: (dist, offset = TANKS.ROTH_165.offset) => {
      const distance = dist + offset;
      const value =
        0.0000862916 * (distance * distance * distance) +
        -0.0052099 * (distance * distance) +
        -2.83872 * distance +
        157.497;
      if (value > TANKS.ROTH_165.gallons) {
        return TANKS.ROTH_165.gallons;
      } else if (value < 0) {
        return 0;
      }
      return Math.round(value);
    },
  },
  HIGH_500: {
    key: 'HIGH_500',
    name: 'Highland 500 gallon',
    height: 48,
    width: 48,
    length: 65,
    offset: 0,
    gallons: 509,
    actualCapacity: 475,
    isActive: true,
    sortId: 22,
    calculateGallonsRemaining: (dist, offset = TANKS.HIGH_500.offset) => {
      const distance = dist + offset;
      const value =
        0.0050872 * (distance * distance * distance) +
        -0.366263 * (distance * distance) +
        -4.89684 * distance +
        512.751;
      if (value > TANKS.HIGH_500.gallons) {
        return value;
      } else if (value < 0) {
        return 0;
      }
      return Math.round(value);
    },
  },
};

const tanks = orderBy(values(TANKS), ['sortId'], ['asc']);
const activeTanks = tanks.filter((tank) => tank.isActive);

module.exports = TANKS;
module.exports.tanks = tanks;
module.exports.activeTanks = activeTanks;
module.exports.activeTankOptions = activeTanks.map((tank) => ({
  label: tank.name,
  value: tank.key,
}));
module.exports.tankOptions = tanks.map((tank) => ({
  label: tank.name,
  value: tank.key,
}));
